import { ROUTES } from '../constants/routes';
import ComplianceWelcomeContainer from './ComplianceWelcome/ComplianceWelcomeContainer';
import ComplianceFormContainer from './ComplianceForm/ComplianceFormContainer';
import ComplianceProviderContainer from './ComplianceProvider/ComplianceProviderContainer';
import CoverageVerifiedContainer from './CoverageVerified/CoverageVerifiedContainer';
import AlreadyCoverageVerifiedContainer from './AlreadyCoverageVerified/AlreadyCoverageVerifiedContainer';
import NoPolicyLocatedContainer from './NoPolicyLocated/NoPolicyLocatedContainer';
import NoBuildingLocatedContainer from './NoBuildingLocated/NoBuildingLocatedContainer';
import CoverageErrorsContainer from './CoverageErrors/CoverageErrorsContainer';
import Compliance from './Compliance/Compliance';
import AlreadyCoveragePurchasedContainer from './AlreadyCoveragePurchased/AlreadyCoveragePurchasedContainer';
import Error404Container from './Error404/Error404Container';
import TermsContainer from './Terms/TermsContainer';
import ConsumerReportsContainer from './ConsumerReports/ConsumerReportsContainer';
import BlankLayout from '../layouts/BlankLayout';
import { lazy } from 'react';
import { ComplianceTermsContainer } from './ComplianceTerms';
import UploadSuccessContainer from './UploadSuccess/UploadSuccessContainer';
import PaymentMsiContainer from './payment-msi/PaymentMsiContainer';

const StartApplicationContainer = lazy(() => import('./StartApplication/StartApplicationContainer'));
const LearnPageContainer = lazy(() => import('./Learn/LearnContainer'));
const QuoteInformationContainer = lazy(
  () => import('./QuoteInformation/QuoteInformationContainer'),
);
const CoveragesDetailsContainer = lazy(
  () => import('./CoveragesDetails/CoveragesDetailsContainer'),
);
const ConfirmationContainer = lazy(
  () => import('./Confirmation/ConfirmationContainer'),
);
const BuildingContainer = lazy(() => import('./Building/BuildingContainer'));
const OrganisationContainer = lazy(() => import('./Organisation/OrganisationContainer'));
const CompanyContainer = lazy(() => import('./Company/CompanyContainer'));
const PaymentMsiCrossSellContainer = lazy(
  () => import('./payment-msi-cross-sell/PaymentMsiCrossSellContainer'),
);

export const routes = [
  {
    path: ROUTES.LEARN_PATH,
    component: LearnPageContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.BUILDING_TYPE_PATH,
    component: BuildingContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.BUILDING_PATH,
    component: BuildingContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.ORGANISATION_PATH,
    component: OrganisationContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPANY_PATH,
    component: CompanyContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_WELCOME_PATH,
    component: ComplianceWelcomeContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_PATH,
    component: ComplianceFormContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_TERMS_PATH,
    component: ComplianceTermsContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_PROVIDERS_PATH,
    component: ComplianceProviderContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_VERIFIED_PATH,
    component: CoverageVerifiedContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_ALREADY_VERIFIED_PATH,
    component: AlreadyCoverageVerifiedContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_NO_POLICY_PATH,
    component: NoPolicyLocatedContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_NO_BUILDING_PATH,
    component: NoBuildingLocatedContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_COVERAGE_NOT_COMPLIANT_PATH,
    component: CoverageErrorsContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_UPLOAD_SUCCESS_PATH,
    component: UploadSuccessContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COMPLIANCE_COVIE_PATH,
    component: Compliance,
    layout: BlankLayout,
  },
  {
    path: ROUTES.START_APPLICATION_PATH,
    component: StartApplicationContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.QUOTE_INFORMATION_PATH,
    component: QuoteInformationContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.COVERAGES_DETAIL_PATH,
    component: CoveragesDetailsContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.PAYMENT_PATH,
    component: PaymentMsiContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.PAYMENT_CROSS_SELL_PATH,
    component: PaymentMsiCrossSellContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.CONFIRMATION_PATH,
    component: ConfirmationContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.ALREADY_PURCHASED_PATH,
    component: AlreadyCoveragePurchasedContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.ERROR_PATH,
    component: Error404Container,
    layout: BlankLayout,
  },
  {
    path: ROUTES.SERVICE_TERMS_PATH,
    component: TermsContainer,
    layout: BlankLayout,
  },
  {
    path: ROUTES.SERVICE_CONSUMER_REPORTS_NOTICE_PATH,
    component: ConsumerReportsContainer,
    layout: BlankLayout,
  },
];

